import Vue from 'vue'
import VueRouter from "vue-router"
import SwAlert from "vue-sweetalert"
import VueTheMask from 'vue-the-mask'
import money from 'v-money'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import App from './App.vue'
import router from './routes'
import api from '@/api'
import store from './store'
import axios from 'axios'
// import { Icon }  from 'leaflet'
// import 'leaflet/dist/leaflet.css'


Vue.use(VueRouter);
Vue.use(SwAlert);
Vue.use(VueTheMask);
Vue.use(money, {precision: 2});

//axios.defaults.baseURL = 'http://api.ca.ibiuna.lliege.com.br:8080';
axios.defaults.baseURL = 'https://api.ca.ibiuna.lliege.com.br';

window.store = store;
window.api = api;
window.axios = axios;

let access_token = store.getters.pegaAccessToken;

if (access_token)
   axios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;

// delete Icon.Default.prototype._getIconUrl;
//
// Icon.Default.mergeOptions({
//     iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
//     iconUrl: require('leaflet/dist/images/marker-icon.png'),
//     shadowUrl: require('leaflet/dist/images/marker-shadow.png')
// });

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
